import { TPartnerData } from '@types';

const partnerData: Record<number, Pick<TPartnerData, 'extraData'>> = {
  1: {
    extraData: {},
  },
};

export default partnerData;
